import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f0e99b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-settings mb-5" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "wrapper bg-light rounded p-3 mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "crowdsource", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 mb-3 mb-xl-0" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "px-3 pb-3" }
const _hoisted_13 = { class: "bg-medium-grey rounded text-white text-nowrap px-3 py-2" }
const _hoisted_14 = { class: "pb-3" }
const _hoisted_15 = { class: "px-3 pb-3" }
const _hoisted_16 = { class: "bg-medium-grey rounded text-white text-nowrap px-3 py-2" }
const _hoisted_17 = { class: "pb-3" }
const _hoisted_18 = { class: "px-3 pb-3" }
const _hoisted_19 = { class: "bg-medium-grey rounded text-white text-nowrap px-3 py-2" }
const _hoisted_20 = { class: "pb-3" }
const _hoisted_21 = { class: "px-3 pb-3" }
const _hoisted_22 = { class: "bg-medium-grey rounded text-white text-nowrap px-3 py-2" }
const _hoisted_23 = { class: "pb-3" }
const _hoisted_24 = { class: "px-3 pb-3" }
const _hoisted_25 = { class: "bg-medium-grey rounded text-white text-nowrap px-3 py-2" }
const _hoisted_26 = { class: "pb-3" }
const _hoisted_27 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1))
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { class: "bg-white border border-1 rounded p-3 mb-2" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 mb-3" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "insights", -1))
const _hoisted_40 = { class: "border border-1 p-2" }
const _hoisted_41 = { class: "row gx-5" }
const _hoisted_42 = { class: "col-auto" }
const _hoisted_43 = { class: "col-auto" }
const _hoisted_44 = { class: "col-auto" }
const _hoisted_45 = { class: "mb-1" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = { class: "bg-white border border-1 rounded p-3 mb-2" }
const _hoisted_49 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 mb-3" }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "visibility", -1))
const _hoisted_52 = { class: "border border-1 p-2" }
const _hoisted_53 = { class: "pe-5" }
const _hoisted_54 = { class: "fw-bold" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { class: "fw-bold" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = { class: "align-top" }
const _hoisted_59 = ["data-bs-title"]
const _hoisted_60 = { class: "pe-5" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "align-top" }, [
  /*#__PURE__*/_createElementVNode("span", null, "€ 25,12")
], -1))
const _hoisted_62 = { class: "pe-5" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = { class: "align-top" }
const _hoisted_66 = ["data-bs-title"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas info-icon-small" }, "info", -1))
const _hoisted_68 = { class: "col-auto" }
const _hoisted_69 = { class: "btn btn-primary" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_RangeSlider = _resolveComponent("RangeSlider")!
  const _component_InputRadio = _resolveComponent("InputRadio")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('basePrices'),
          mb: 2
        }, null, 8, ["title"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.basePricesUI.getError()
        }, null, 8, ["error"]),
        (!_ctx.basePricesUI.getIsReady())
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : (_openBlock(), _createBlock(_component_dp_form, {
              key: 1,
              as: "form",
              onSubmit: _ctx.submitData,
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("h2", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(_toDisplayString(_ctx.$t('usedPriceSource')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('usedPriceSourceDescription')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, "1. " + _toDisplayString(_ctx.$t('websiteManagement')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('websiteManagementDescription')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, "2. " + _toDisplayString(_ctx.$t('softwareSync')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('softwareSyncDescription')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, "3. " + _toDisplayString(_ctx.$t('apbPublicPrice')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('apbPublicPriceDescription')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, "4. " + _toDisplayString(_ctx.$t('referencePrice')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t('referencePriceDescription')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, "5. " + _toDisplayString(_ctx.$t('noPrice')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$t('noPriceDescription')), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("h2", _hoisted_30, [
                            _hoisted_31,
                            _createTextVNode(_toDisplayString(_ctx.$t('settingsReferencePrice')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("section", _hoisted_36, [
                                _createElementVNode("h3", _hoisted_37, [
                                  _createElementVNode("span", _hoisted_38, [
                                    _hoisted_39,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('referencePriceCorrection')), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('referencePriceCorrectionDescription')), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('priceCorrection')) + ": ", 1),
                                      _createElementVNode("div", _hoisted_43, [
                                        _createVNode(_component_InputNumber, {
                                          modelValue: _ctx.priceSettings.global_correction_value,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceSettings.global_correction_value) = $event)),
                                          name: "correction",
                                          rules: "required|min:-50|max:50",
                                          min: -50,
                                          max: 50,
                                          step: 1,
                                          errors: errors,
                                          label: "",
                                          "field-class": "text-center",
                                          disabled: _ctx.priceSettings.is_opt_out_for_price_sharing
                                        }, null, 8, ["modelValue", "errors", "disabled"]),
                                        _createVNode(_component_RangeSlider, {
                                          modelValue: _ctx.priceSettings.global_correction_value,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceSettings.global_correction_value) = $event)),
                                          min: -50,
                                          max: 50,
                                          step: 1,
                                          disabled: _ctx.priceSettings.is_opt_out_for_price_sharing
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("p", _hoisted_45, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('correctionBottom')), 1),
                                          _hoisted_46,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('correctionNone')), 1),
                                          _hoisted_47,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('correctionTop')), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("section", _hoisted_48, [
                                _createElementVNode("h3", _hoisted_49, [
                                  _createElementVNode("span", _hoisted_50, [
                                    _hoisted_51,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('visualization')), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("table", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_53, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_InputRadio, {
                                            modelValue: _ctx.priceSettings.presentation_code,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceSettings.presentation_code) = $event)),
                                            label: _ctx.$t('showReferencePriceWithIndication'),
                                            value: _ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_AND_REF_PRICE,
                                            name: "visualization",
                                            errors: errors,
                                            labelClass: "fw-bold",
                                            id: _ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_AND_REF_PRICE,
                                            disabled: _ctx.priceSettings.is_opt_out_for_price_sharing
                                          }, null, 8, ["modelValue", "label", "value", "errors", "id", "disabled"])
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass({
                                  'text-disabled': _ctx.priceSettings.is_opt_out_for_price_sharing,
                                  'ps-5 mt-n2': true
                                }),
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPresentationCode(_ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_AND_REF_PRICE)))
                                        }, [
                                          _createTextVNode(" • "),
                                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('indication')), 1),
                                          _createTextVNode(": " + _toDisplayString(_ctx.$t('priceItalicUnderlined')), 1),
                                          _hoisted_55,
                                          _createTextVNode(" • "),
                                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('hoverForMessage')) + ":", 1),
                                          _hoisted_57,
                                          _createTextVNode("    '" + _toDisplayString(_ctx.$t('referencePriceCanDiffer')) + "' ", 1)
                                        ], 2)
                                      ]),
                                      _createElementVNode("td", _hoisted_58, [
                                        _createElementVNode("span", {
                                          class: "dashed-underline fst-italic",
                                          "data-bs-toggle": "tooltip",
                                          "data-bs-title": _ctx.$t('referencePriceCanDiffer')
                                        }, "€ 25,12", 8, _hoisted_59)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_60, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_InputRadio, {
                                            modelValue: _ctx.priceSettings.presentation_code,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.priceSettings.presentation_code) = $event)),
                                            label: _ctx.$t('showReferencePriceWithoutIndication'),
                                            value: _ctx.ReferencePricePresentationEnum.NO_NOTIFICATION_REF_PRICE_AS_NORMAL_PRICE,
                                            name: "visualization",
                                            errors: errors,
                                            labelClass: "fw-bold",
                                            id: _ctx.ReferencePricePresentationEnum.NO_NOTIFICATION_REF_PRICE_AS_NORMAL_PRICE,
                                            disabled: _ctx.priceSettings.is_opt_out_for_price_sharing
                                          }, null, 8, ["modelValue", "label", "value", "errors", "id", "disabled"])
                                        ])
                                      ]),
                                      _hoisted_61
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_62, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_InputRadio, {
                                            modelValue: _ctx.priceSettings.presentation_code,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.priceSettings.presentation_code) = $event)),
                                            label: _ctx.$t('showNoPriceOnlyMessage'),
                                            value: _ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_NO_PRICE,
                                            name: "visualization",
                                            errors: errors,
                                            labelClass: "fw-bold",
                                            id: _ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_NO_PRICE
                                          }, null, 8, ["modelValue", "label", "value", "errors", "id"])
                                        ]),
                                        _createElementVNode("div", {
                                          class: "ps-5 mt-n2",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectPresentationCode(_ctx.ReferencePricePresentationEnum.SHOW_NOTIFICATION_NO_PRICE)))
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('iconInsteadOfPrice')), 1),
                                          _hoisted_63,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('hoverOverIconForMessage')) + ":", 1),
                                          _hoisted_64,
                                          _createTextVNode("    '" + _toDisplayString(_ctx.$t('priceInPharmacy')) + "' ", 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_65, [
                                        _createElementVNode("span", {
                                          "data-bs-toggle": "tooltip",
                                          "data-bs-title": _ctx.$t('priceInPharmacy')
                                        }, [
                                          _createTextVNode("€ "),
                                          _hoisted_67
                                        ], 8, _hoisted_66)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, _toDisplayString(_ctx.$t('referencePriceOptOutDescription')), 1),
                              _createElementVNode("div", null, [
                                _createVNode(_component_input_checkbox_boolean, {
                                  modelValue: _ctx.priceSettings.is_opt_out_for_price_sharing,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceSettings.is_opt_out_for_price_sharing) = $event)),
                                  label: 'Opt-out',
                                  name: "optOut",
                                  errors: errors,
                                  onChange: _ctx.optOutChanged
                                }, null, 8, ["modelValue", "errors", "onChange"])
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("button", _hoisted_69, _toDisplayString(_ctx.$t('save')), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
      ]),
      _: 1
    }),
    _hoisted_70,
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}